class Popup {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-user-popup="modal"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			let $scope = $(scope);
			let modal = bootstrap.Modal.getOrCreateInstance(scope, $scope.data());

			if(! this._isClosed()) {
				modal.show();
			}

			$scope.on('hide.bs.modal', event => {
				this._closePopup();
			});
		})
	}

	_isClosed() {
		let closed = sessionStorage.getItem('popup_closed');
		if(!closed) {
			return false;
		}
		return true;
	}

	_closePopup() {
		sessionStorage.setItem('popup_closed', 'true');
	}
}

export default new Popup;